import { Col, Row } from 'antd';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import styled from 'styled-components';
import { TeamData } from 'Types/SRITypes';
import { formatNumberWithCommas } from 'Utils/UtilityFunctions';
import {
  boxShadow, primaryHeadingColor, secondaryFont, wMBold,
} from 'Utils/utilsStyle';

type Props = {
  teamRankLoading?: boolean,
  teamDetailsData: TeamData
} | typeof defaultProps;

const defaultProps = {
  teamRankLoading: false,
  teamDetailsData: {} as TeamData,
};

const BoxDisplay = styled.div`
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #fff;
  padding: 24px 42px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h1 {
    font-size: 28px;
    font-weight: ${wMBold};
    letter-spacing: -0.7px;
    font-family: ${secondaryFont};
    color: ${primaryHeadingColor};
  }
  h3 {
    font-size: 37px;
    font-weight: ${wMBold};
    letter-spacing: -0.7px;
    font-family: ${secondaryFont};
    color: #1EC252;
  }
  img { 
    width: 69px;
    height: 75px;
  }
`;

const TeamDeatilsCards = function TeamDeatilsCards(props: Props) {
  const { teamRankLoading, teamDetailsData } = props;
  const { team_avg_rank: rank, team_avg_score: score, team_level: level } = teamDetailsData;
  const formattedScoreCount = formatNumberWithCommas(score);

  return (
    <Row gutter={16}>
      {teamRankLoading
        ? (
          <Row gutter={[16, 16]} className="w-100">
            {[1, 2, 3].map(() => <Col span={8}><SkeletonCustom height="182px" width="100%" margin="0 0 20px 0" /></Col>)}
          </Row>
        )
        : (
          <>
            {rank ? (
              <Col span={8}>
                <BoxDisplay>
                  <h1>
                    Team Rankings
                  </h1>
                  <h3>
                    {`${rank} / ${teamDetailsData?.total_teams_in_company}`}
                  </h3>
                </BoxDisplay>
              </Col>
            ) : null}
            {score ? (
              <Col span={8}>
                <BoxDisplay className="states-average-score">
                  <h1>
                    Average Score / Month
                  </h1>
                  <h3>
                    {formattedScoreCount}
                  </h3>
                </BoxDisplay>
              </Col>
            ) : null}
            {level ? (
              <Col span={8}>
                <BoxDisplay>
                  <h1>
                    Team Level
                  </h1>
                  <img src={level?.image} alt="team level" />
                </BoxDisplay>
              </Col>
            ) : null}
          </>
        )}
    </Row>
  );
};

TeamDeatilsCards.defaultProps = defaultProps;
export default TeamDeatilsCards;
